import React from 'react';

import PanelControlDelete from "../UI/ReactPanelControlDelete";
import DropdownProgressLevel from "../UI/ReactDropdownProgressLevel";
import DropdownProgress from "../UI/ReactDropdownProgress";
import DropdownAttitude from "../UI/ReactDropdownAttitude";
import DropdownWorkingAtYearAndLevel from "../UI/ReactDropdownWorkingAtYearAndLevel";
import DropdownQualification from "../UI/ReactDropdownQualification";
import UserInput from "../UI/ReactUserInput";

export default class ChildProgressReviewPanelLegacy extends React.Component
{
	static get defaultProps()
	{
		return
		{
			{
				prevButtonRequired: true;
				nextButtonRequired: true;
				mode: 'create';
				userid: '';
				usertype:0;
				title: ""
			}
		}
		;
	}

	constructor(props)
	{
		super(props);

		this.state = {
			data: this.props.data,
			mode: this.props.mode,
			panelNumber: this.props.panelNumber,
			displayErrors: this.props.displayErrors
		};

		this.onDirty = this.onDirty.bind(this);
		this.onClickDelete = this.onClickDelete.bind(this);
	}

	UNSAFE_componentWillReceiveProps(newProps)
	{
		if (newProps.displayErrors != this.state.displayErrors) {
			this.setState({displayErrors: newProps.displayErrors});
		}
	}

	getFormDefinition()
	{
		const items = [
			{ref: 'InputCurrentLevel', item_name: 'current_level', default: null},
			{ref: 'InputAgeRelatedCurriculum', item_name: 'age_related_curriculum'},
			{ref: 'InputQualification', item_name: 'ks4_qualification'},
			{ref: 'InputFinalPredictedLevel', item_name: 'final_predicted_level'},
			{ref: 'InputAttitude', item_name: 'attitude'},
			{ref: 'InputAttitudeToHomework', item_name: 'attitude_to_homework'},
			{ref: 'InputProgressAchieved', item_name: 'progress_achieved'},
		];

		return items;
	}

	getFormItems(object, formDefinition)
	{
		let n = object;

		for (let i in formDefinition) {
			let ref = formDefinition[i]['ref'];
			let data_item = formDefinition[i]['item_name'];
			let val = null;

			if (this.refs[ref] != null) {
				val = this.refs[ref].getValue();
			} else {
				if (formDefinition[i]['default'] != null) {
					val = formDefinition[i]['default'];
				} else {
					val = null;
				}
			}

			n[data_item] = val;
		}

		return n;
	}

	isDirtyFormItems()
	{
		let result = false ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			let ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				if (this.refs[ref].isDirty())
				{
					result = true;
				}
			}
		}

		return result ;
	}

	isValidFormItems()
	{
		let result = true ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			let ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				if (!this.refs[ref].isValid())
				{
					result = false;
					break ;
				}
			}
		}

		return result ;
	}

	setDirtyFormItems( value )
	{
		let result = false ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			let ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				this.refs[ref].setDirty(value) ;
			}
		}

		return result ;
	}

	getFormData()
	{
		let dataItem = {} ;

		dataItem['review_id'] = this.state.data.review_id ;
		dataItem['achievement_id'] = this.state.data.achievement_id ;
		dataItem['expectation_achieved'] = null ;
		dataItem['description'] =  this.state.data.description;

		dataItem = this.getFormItems( dataItem, this.getFormDefinition()) ;

		if ( this.state.data.achievement_id == 0 )
		{
			dataItem['new'] = true ;
		}

		return dataItem ;
	}

	onDirty()
	{
		if ( this.props.onDirty != null )
		{
			this.props.onDirty();
		}
	}

	isValid ()
	{
		return this.isValidFormItems() ;
	}

	isDirty()
	{
		return this.isDirtyFormItems() ;
	}

	setDirty( value )
	{
		this.setDirtyFormItems( value );
	}
	
	getYearGroup( year_id )
	{
		// Default to year 1-8 if none provided
		let year_group_id = 1;

		switch ( +year_id )
		{
			case 14:
			case 15:
			case 17:
				year_group_id = 0 ;
				break ;
			case 1:
			case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
				year_group_id = 1 ;
				break;
            case 9:
            case 10:
            case 11:
            	year_group_id = 2 ;
            	break ;
			default:
				year_group_id = 1 ;
				break ;
		}

		return year_group_id ;
	}

	row2018Header1_8()
	{
		var lineList=[];

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' },  className: 'col-1 col-md-3'}, "Attitude to Learning")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-2'}, "Predicted to achieve age related expectation (based on prior attainment)")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-2'}, "Age Related Curriculum currently being followed")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-3'}, "Progress Achieved")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-2'}, "Predicted end of year age related achievement (E.g. year 5)")) ;

		return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , lineList );

	}

	row2018Header9_11()
	{
		var lineList=[];

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' },  className: 'col-1 col-md-3'}, "Attitude to Learning")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-2'}, "Predicted grade based on KS2/prior attainment ")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-2'}, "Current Grade")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-3'}, "Progress Achieved")) ;
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, style: { fontWeight: 'bold' }, className: 'col-1 col-md-2'}, "Final predicted Grade(KS4)")) ;

		return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , lineList );

	}

	row2018Content()
	{
		var lineList=[];

		var fieldType = '';

		if ( this.props.readonly == true || this.state.mode == 'view' )
		{
			fieldType = "readonly";
		}

		var obj = this.state.data;

		let classname = 'col-1 col-md-3' ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: classname},
			React.createElement ( DropdownAttitude, {
				validation: { required: true, isDate: false},
				id: 'InputAttitude',
				name: 'InputAttitude',
				ref: 'InputAttitude',
				label: '',
				errorText: 'Valid selection required',
				defaultValue: obj.attitude,
				tabIndex: 1 + (6 * this.state.panelNumber),
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				onDirty: this.onDirty,
				key: this.keyCount++
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( UserInput, {
				validation: { required: true, isDate: false},
				id: 'InputCurrentPredictedLevel',
				name: 'InputCurrentPredictedLevel',
				ref: 'InputCurrentPredictedLevel',
				labelText: '',
				errorText: 'Valid selection required',
				value: obj.current_predicted_level,
				tabIndex: 1 + (6 * this.state.panelNumber),
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				containerClassName: 'input-group',
				onDirty: this.onDirty,
				key: this.keyCount++
			}))) ;

		if ( this.getYearGroup(this.props.year_id) == 2 )
		{
			lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
				React.createElement ( UserInput, {
					validation: { required: true, isDate: false},
					id: 'InputCurrentLevel',
					name: 'InputCurrentLevel',
					ref: 'InputCurrentLevel',
					labelText: '',
					errorText: 'Valid selection required',
					value: obj.current_level,
					tabIndex: 1 + (6 * this.state.panelNumber),
					readOnly: fieldType,
					displayErrors:this.state.displayErrors,
					containerClassName: 'input-group',
					onDirty: this.onDirty,
					key: this.keyCount++
				}))) ;
		}

		if ( this.getYearGroup(this.props.year_id) == 1 ) {
			lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-1 col-md-2'},
				React.createElement(UserInput, {
					validation: {required: true, isDate: false},
					id: 'InputAgeRelatedCurriculum',
					name: 'InputAgeRelatedCurriculum',
					ref: 'InputAgeRelatedCurriculum',
					labelText: '',
					errorText: 'Valid selection required',
					value: obj.age_related_curriculum,
					tabIndex: 1 + (6 * this.state.panelNumber),
					readOnly: fieldType,
					onDirty: this.onDirty,
					displayErrors: this.state.displayErrors,
					containerClassName: 'input-group',
					key: this.keyCount++
				})));
		}

		classname = 'col-1 col-md-3'

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: classname},
			React.createElement ( DropdownProgressLevel, {
				validation: { required: true },
				id: 'InputProgressLevel',
				name: 'InputProgressLevel',
				ref: 'InputProgressLevel',
				label: '',
				errorText: 'Valid progress required',
				defaultValue: obj.progress_achieved,
				tabIndex: 3  + (6 * this.state.panelNumber),
				readOnly: fieldType,
				onDirty: this.onDirty,
				displayErrors:this.state.displayErrors,
				key: this.keyCount++
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( UserInput, {
				validation: { required: false, isDate: false},
				id: 'InputFinalPredictedLevel',
				name: 'InputFinalPredictedLevel',
				ref: 'InputFinalPredictedLevel',
				labelText: '',
				errorText: 'Valid selection required',
				value: obj.final_predicted_level,
				tabIndex: 1 + (6 * this.state.panelNumber),
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				onDirty: this.onDirty,
				containerClassName: 'input-group',
				key: this.keyCount++
			}))) ;


		return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , lineList );

	}

	changeSubjectQualification ( achievement_id, qual )
	{
		let data = this.state.data ;

		data.ks4_qualification = qual ;

		if ( qual != 1 )
		{
			data.final_predicted_level = '' ;
		}

		this.setState ( { data: data }) ;
	}

	renderPanel (  )
	{
		var lineList=[];

		if ( this.getYearGroup(this.props.year_id) == 1 )
		{
			lineList.push ( this.row2018Header1_8()) ;
		}
		else
		{
			lineList.push ( this.row2018Header9_11()) ;
		}

		lineList.push ( this.row2018Content()) ;

		return lineList ;
	}

	onClickDelete()
	{
		if ( this.props.onDelete != null )
		{
            this.props.onDelete ( this.props.data ) ;
		}
	}

	panelHeader ( title, allow_delete )
	{
		let lineList = [] ;
        let contents = [] ;

        contents.push ( React.createElement ( 'span', { key: this.keyCount++ }, title ));

        let disabled = true ;
		let handler =  null ;

        if ( allow_delete == 1 )
		{
			handler = this.onClickDelete ;
			disabled = false ;
		}

        contents.push ( React.createElement (  PanelControlDelete, { key: this.keyCount++, disabled: disabled, onClick: handler} ));

        lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-heading' }, contents ));

        return lineList ;
    }

	formRows ()
	{
		var lineList=[];
		
		var obj = this.state.data ;
			
		lineList.push ( this.panelHeader (obj.description, obj.allow_delete));

		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-body' }, this.renderPanel()));

		return lineList ;
	}
	
	render() 
    {
		this.keyCount=0;

        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default panel-subject'}, this.formRows());
    }
};